module.exports = __webpack_public_path__ + "DINNextLTPro-MediumItalic.woff2?79a898f956fa21c7222b3cc0c1fa6433";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-MediumItalic.woff2
// module id = 1436
// module chunks = 0